import { Component } from 'react'
import injectSheet from 'react-jss'
import { TweenMax, Power2 } from 'gsap'
import 'intersection-observer' // optional polyfill
import HTMLParser from 'react-html-parser'
import Observer from '@researchgate/react-intersection-observer'
import DelayLink from '@/components/DelayLink'
import SplitText from '@/vendors/bonus-files-for-npm-users/umd/SplitText'
import style from './style'

// const clamp = (val, min, max) => Math.min(Math.max(val, min), max)

/**
 * BlockTitle
 * @class BlockTitle
 * @example
 * <BlockTitle />
 */
class BlockTitle extends Component {
  /*------------------------------
  Component Will Mount
  ------------------------------*/
  componentWillMount() {
    this.props.onRef(this)
    this.setState({
      hover: false,
    })
    this.opt = {
      a: {
        ease: Power2.easeOut,
        t: 1.5,
        d: 0.15,
        // rotation: -13,
      },
    }
    this.mySplitText = null
    this.splitted = false
    this.handleIntersection = this.handleIntersection.bind(this)
  }

  /*------------------------------
  Component Did Mount
  ------------------------------*/
  componentDidMount() {
    this.initialize = false
    this.props.onRef(this)
    this.hover = ''
    const { classes } = this.props
    this.$ = {
      root: this.node,
      preTitle: this.node.getElementsByClassName(classes.preTitle),
      subTitle: this.node.getElementsByClassName(classes.subTitle),
      title: this.node.getElementsByClassName(classes.title),
      paragraph: this.node.getElementsByClassName(classes.paragrah),
    }

    if (this.$.title[0]) {
      this.mySplitText = new SplitText(this.$.title[0], { type: 'words' })
    }

    // if (this.props.data.title !== '') {
    //   this.setSplitText(this.$.title)
    // }
    // if (this.props.split) {
    //   TweenMax.set(this.$.title, { autoAlpha: 0 })
    //   TweenMax.set(this.$.subTitle, { autoAlpha: 0 })
    //   this.setSplitText()
    // }
    // if (this.props.transition === 'entered') {
    //   if ((this.props.data.title !== '') && (this.props.inview) && (this.props.split)) {
    //     this.setSplitText()
    //     this.animateIn()
    //   }
    // }
  }

  /*------------------------------
  Component Did Update
  ------------------------------*/
  componentDidUpdate(prevProps) {
    // if (this.props.data.title !== '') {
    //   this.setSplitText(this.$.title)
    // }
    // if (this.props.transition !== prevProps.transition) {
    //   if (this.props.transition === 'entered') {
    //     if ((this.props.data.title !== '') && (this.props.inview) && (this.props.split)) {
    //       // this.setSplitText()
    //       // this.animateIn()
    //     }
    //   }
    //   if (this.props.transition === 'exiting') {
    //     if (this.props.data.title !== '') {
    //       // this.animateOut()
    //     }
    //   }
    // }
    // if (this.props.data.title !== prevProps.data.title) {
    //   if ((this.props.data.title !== '') && (this.props.split)) {
    //     // this.setSplitText(this.$.title)
    //   }
    // }
    if (this.props.hover !== prevProps.hover) {
      this.updateHover(this.props.hover)
    }
    // if ((this.props.data.title !== '') && (this.props.inview !== prevProps.inview)) {
    //   if ((this.props.data.title !== '') && (this.props.inview) && (this.props.split)) {
    //     // this.setSplitText()
    //     // this.animateIn()
    //   }
    // }
  }

  /*------------------------------
  Set Split Text
  ------------------------------*/
  setSplitText() {
    // window.console.log('self.splitted ---> ', this.splitted)
    // window.console.log('time ---> ', Date.now())

    const el = []
    el[0] = this.$.title
    if (this.$.subTitle.length > 0) {
      el[1] = this.$.subTitle
    }

    if ((this.props.split) && (!this.splitted)) {
      this.splitted = true
      this.mySplitText = null
      this.mySplitText = new SplitText(el, { type: 'lines, chars' })
      TweenMax.set(this.mySplitText.chars, { y: '115%', x: '-12px' })
      TweenMax.set(el, { autoAlpha: 1 })
    }
  }

  /*------------------------------
  Get Render Content
  ------------------------------*/
  getRenderContent() {
    const self = this
    const { classes, data, back } = self.props
    this.renderContent = null
    this.renderTitle = null
    this.renderPreTitle = null
    this.renderSubTitle = null
    this.renderParagraph = null
    this.renderHeader = null
    if (data !== undefined) {
      if (data.preTitle !== undefined) {
        this.renderPreTitle = (<h3 className={`${classes.preTitle} blockTitle__preTitle`}>{HTMLParser(data.preTitle)}</h3>)
      }
      if (data.subTitle !== undefined) {
        if (back) {
          this.renderSubTitle = (<DelayLink className={`${classes.subTitle} blockTitle__subTitle`} back>{HTMLParser(data.subTitle)}</DelayLink>)
        } else {
          this.renderSubTitle = (<h2 className={`${classes.subTitle} blockTitle__subTitle`}>{HTMLParser(data.subTitle)}</h2>)
        }
      }
      if (self.props.data.title !== undefined) {
        let title = (
          <h1 className={`${classes.title} blockTitle__title`}>{HTMLParser(self.props.data.title)}</h1>
        )

        if (self.props.data.link !== undefined) {
          title = (
            <a href={self.props.data.link} target="_blank" rel="noopener"><h1 className={`${classes.title} blockTitle__title`}>{HTMLParser(self.props.data.title)}</h1></a>
          )
        }

        this.renderTitle = title
      }
      if (data.paragraph !== undefined) {
        this.renderParagraph = (<div className={`${classes.paragraph} blockTitle__paragraph`}>{HTMLParser(data.paragraph)}</div>)
      }
    }
    this.renderContent = (
      <div className={classes.container}>
        {this.renderPreTitle}
        {this.renderSubTitle}
        {this.renderTitle}
        {this.renderParagraph}
      </div>
    )
    return this.renderContent
  }

  // /*------------------------------
  // Animate In
  // ------------------------------*/
  // animateIn() {
  //   const self = this
  //   if (self.props.split) {
  //     TweenMax.staggerTo(self.mySplitText.chars, self.opt.a.t, { y: '0%', x: '0', rotation: 0, ease: self.opt.a.ease, force3D: true }, 0.0007, 0)
  //   }
  // }

  // /*------------------------------
  // Animate Out
  // ------------------------------*/
  // animateOut() {
  //   const self = this
  //   if (self.props.split) {
  //     TweenMax.staggerTo(self.mySplitText.chars, self.opt.a.t, { y: '-115%', x: '12px', rotation: this.opt.a.rotation, ease: self.opt.a.ease, force3D: true }, 0.007, 0)
  //   }
  // }

  /*------------------------------
  Update Hover
  ------------------------------*/
  updateHover(bool) {
    this.setState({
      hover: bool,
    })
  }

  /*------------------------------
  Handle intersection
  ------------------------------*/
  handleIntersection(event) {
    if (this.$ !== undefined) {
      const { subTitle, preTitle } = this.$
      if ((!this.props.noObserver) && (!this.initialize)) {
        this.initialize = true
        TweenMax.set(preTitle, { y: 40, autoAlpha: 0 })
        TweenMax.set(subTitle, { y: 40, autoAlpha: 0 })
        if (this.mySplitText) {
          TweenMax.set(this.mySplitText.words, { y: '110%', autoAlpha: 0 })
        }
      }
      if ((event.isIntersecting) && (!this.props.noObserver)) {
        TweenMax.to(preTitle, 0.5, { y: 0, autoAlpha: 1, ease: this.opt.a.ease })
        TweenMax.to(subTitle, 0.3, { y: 0, autoAlpha: 1, ease: this.opt.a.ease })
        if (this.mySplitText) {
          TweenMax.to(this.mySplitText.words, 1, { y: '0%', autoAlpha: 1, ease: this.opt.a.ease }, 0.1)
        }
      }
    }
  }

  /*------------------------------
  Render
  ------------------------------*/
  render() {
    const { classes, className } = this.props
    const options = {
      onChange: this.handleIntersection,
      rootMargin: '0% 0% -25%',
      onlyOnce: true,
    }
    if (this.state.hover) {
      this.hover = 'hover'
    } else {
      this.hover = ''
    }
    return (
      <div
        className={`${className} ${classes.root} ${this.props.layout} ${this.props.alignTitle} ${this.hover}`}
        ref={(node) => { this.node = node }}
        style={this.props.style}
      >
        <Observer {...options}>
          {/* <div style={{ backgroundColor: 'red' }}> */}
          {this.getRenderContent()}
          {/* </div> */}
        </Observer>
      </div>
    )
  }
}

BlockTitle.defaultProps = {
  alignTitle: 'left',
  width: '100%',
  inview: true,
  split: true,
  back: false,
  onRef: () => {},
}
export default injectSheet(style)(BlockTitle)
